/*
 * @Author: qian.tang
 * @Date: 2023-09-21 10:30:26
 * @LastEditors: Qian Tang qian@itrazotracetech.com
 * @LastEditTime: 2024-01-09 10:04:11
 * @FilePath: \itrazo-portal-dev\src\containers\Pages\AssetManagement\apis\CategoryAPI.tsx
 * @Description: 
 * 
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved. 
 */
import { ASSET_MANAGEMENT_API as AM_API } from "utilities/AdiApi";
import { logError } from '../../RelationshipManagement/utilities/functions'
import { getBizCode } from "utilities/Functions/GlobalHelperFunctions";

const CategoryAPI = {

  getAllCategory: async () => {
    try {
      const url = `${getBizCode()}/categories`
      const res = await AM_API.get(url)
      console.log('getAll res', res)
      return res.data.Items
    } catch (e) {
      logError(e)
      console.log('getAll cate fail...', e)
      throw e
    }
  },
  addCategory: async (payload: any) => {    
    try {
      const res = await AM_API({
        method: 'POST',
        url: `${getBizCode()}/categories`,
        data: payload
      })
      return res
    } catch (e) {
      logError(e)
      throw e
    }
  },
  updateCategory: async (payload: any) => {
    try {
      const res = await AM_API({
        method: 'PUT',
        url: `${getBizCode()}/categories`,
        data: payload
      })
      return res
    } catch (e) {
      logError(e)
      throw e
    }
  },

}

export default CategoryAPI